export default __webpack_public_path__ + "static/media/KimberlyClarkLogoIcon2.0ebe9a14.png";